import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {$accountFactory} from "../../../account/$account.factory";

export class DeliveriesValidationTableRowCtrl implements IController {
  order: any;
  orderId: any;
  onToggle: any;
  onRemove: any;
  onEdit: Function;

  private readonly siteLabels: any;
  private delivery: any;
  private accountName: any;
  private errorFields: any;
  private labelsMap: any;
  private dropOffRef: any;

  /* @ngInject */
  constructor(private $account: $accountFactory, private splitService) {
    this.siteLabels = this.splitService.getSiteLabels();
  }

  $onInit() {
    this.errorFields = [];
    this.labelsMap = _.keyBy(this.siteLabels, 'name');

    this.delivery = this.order.entity.serviceList[0];
    this.dropOffRef = _.find(this.delivery.taskList, (t) => {
      return t.taskSpec.purpose === 'Dropoff';
    });
    this.errorFields = _.map(this.order.errors, (error) => {
      return error.fieldName;
    });
    if (this.order.entity.accountId) {
      this.$account(this.order.entity.accountId).$asyncValue()
        .then((account) => {
          this.accountName = account.name;
        })
    }
  }

  $onChanges(changes) {
    if (changes.orderId && !changes.orderId.isFirstChange()) {
      this.$onInit();
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  getErrorDescriptions() {
    return _.map(this.order.errors, 'description');
  }

  isMissing(type, name) {
    var stringName = 'order.' + _.toLower(type) + '.' + name;
    var matchedError = _.find(this.errorFields, (e) => {
      return _.includes(e, stringName);
    });

    return !_.isUndefined(matchedError);
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesValidationTableRow', {
    require: {
      deliveriesValidationTableCtrl: '^deliveriesValidationTable'
    },
    bindings: {
      order: '<',
      orderId: '<',
      onToggle: '&',
      onRemove: '&',
      onEdit: '&'
    },
    template: require('./deliveries-validation-table-row.html').default,
    controller: DeliveriesValidationTableRowCtrl
  });

